var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTeleBatteryWarningSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_tele_battery_warning_small",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Box",
    width: 16,
    height: 16,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-car-battery",
    "data-name": "Icon awesome-car-battery",
    d: "M13.783,6.338h-.919V4.959A.459.459,0,0,0,12.4,4.5H9.648a.459.459,0,0,0-.459.459V6.338H5.513V4.959A.459.459,0,0,0,5.054,4.5H2.3a.459.459,0,0,0-.459.459V6.338H.919A.919.919,0,0,0,0,7.257v7.351a.919.919,0,0,0,.919.919H13.783a.919.919,0,0,0,.919-.919V7.257A.919.919,0,0,0,13.783,6.338Zm-8.27,3.905a.23.23,0,0,1-.23.23H2.067a.23.23,0,0,1-.23-.23V9.783a.23.23,0,0,1,.23-.23H5.283a.23.23,0,0,1,.23.23Zm7.351,0a.23.23,0,0,1-.23.23H11.486v1.149a.23.23,0,0,1-.23.23H10.8a.23.23,0,0,1-.23-.23V10.472H9.418a.23.23,0,0,1-.23-.23V9.783a.23.23,0,0,1,.23-.23h1.149V8.405a.23.23,0,0,1,.23-.23h.459a.23.23,0,0,1,.23.23V9.554h1.149a.23.23,0,0,1,.23.23Z",
    transform: "translate(0.676 -1.805)",
    fill: "#e88f25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTeleBatteryWarningSmall);
export default __webpack_public_path__ + "static/media/ic_tele_battery_warning_small.02c2540c6d9c86c539cba304dd04bdf8.svg";
export { ForwardRef as ReactComponent };